<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Loan Requests</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Loan</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Request Loan</a
                >
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3" v-for="item in loanTypes" :key="item.typeId">
              <div class="stats-info">
                <h6>{{ item.description }}</h6>
                <h5>{{ item.tenor }} Months Maximum</h5>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="sortedLoans"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.repaymentStartDate`]="{ item }">
                    {{
                      item.repaymentStartDate
                        ? new Date(item.repaymentStartDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div
                      class="dropdown dropdown-action"
                      v-if="item.status == 0"
                    >
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="openDialogStatus(item)"
                          v-if="
                            item.status == 0 &&
                              item.approvedByManager != null &&
                              item.approvedByAGM == null
                          "
                          ><i class="fa fa-check"></i> Approve or Reject</a
                        >
                        <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'loanhistory',
                          params: { id: item.employee.id }
                        }"> View History</router-link>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && !item.approvedByManager"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="
                        item.status == 0 &&
                          item.approvedByManager &&
                          !item.approvedByAGM
                      "
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      HOD Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="
                        item.status == 0 &&
                          item.approvedByManager &&
                          item.approvedByAGM &&
                          !item.approvedBy
                      "
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="closeStatus"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Loan Request Approve</h3>
                  <p>Are you sure want to approve for this loan?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeLoanStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeLoanStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogStatus: false,
      dialogDelete: false,
      media: "data:image/jpeg;base64,",
      headers: [
        { text: "Employee", value: "profile" },
        { text: "Loan Type", value: "loanType.description" },
        { text: "Amount", value: "amount" },
        { text: "Tenor (per month)", value: "actualTenor" },
        { text: "Repayment Amount", value: "repaymentAmount" },
        { text: "Repayment StartDate", value: "repaymentStartDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      loanTypeId: 0,
      amount: 0,
      tenor: 0,
      isManager: false,
      loan: {},
      loans: [],
      loanTypes: [],
      maxTenor: 0,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      error: "",
      message: "",
      status: ""
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeEdit();
    },
    tenor(val) {
      if (val > 0 && this.amount > 0 && this.loanTypeId > 0) {
        this.calculateLoan(val);
      }
    },
    loanTypeId(val) {
      var type = this.loanTypes.filter(c => (c.id = val));
      if (type) {
        this.maxTenor = type.tenor;
      } else {
        this.maxTenor = 6;
      }
    }
  },
  computed: {
    sortedLoans: function() {
      function compare(a, b) {
        if (
          new Date(a.requestDate).getTime() < new Date(b.requestDate).getTime()
        )
          return 1;
        if (
          new Date(a.requestDate).getTime() > new Date(b.requestDate).getTime()
        )
          return -1;
        return 0;
      }

      return this.loans ? this.loans.sort(compare) : this.loans;
    }
  },
  methods: {
    clearModel() {
      this.amount = 0;
      this.tenor = 0;
      this.loanTypeId = 0;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLoan(item) {
      this.loan = item;
      this.dialogEdit = true;
      // console.log(`item`, item)
    },
    openDialogStatus(item) {
      this.loan = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },

    setDeleteLoan(item) {
      this.loan = item;
      this.dialogDelete = true;
    },

    deleteLoan() {
      // const id = this.employeeLeaves.id;
      console.log(this.loan.id);
      employeeService.removeLoanRequest(this.loan.id).then(
        id => {
          employeeService
            .getLoanRequestsByEmployee(this.currentUser.employee.id)
            .then(o => {
              this.loans = o;

              this.dialogDelete = false;
            });
        },
        e => {
          this.error = "Loan is being used in some information";
        }
      );
    },

    setLoan(item) {
      this.loan = item;
    },

    updateLoan() {
      this.submitted = true;
      this.loading = true;
      employeeService.updateLoan(this.loan).then(
        id => {
          employeeService
            .getLoanRequestsByEmployee(this.currentUser.employee.id)
            .then(o => {
              this.loans = o;
              this.closeEdit();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    changeLoanStatus(status) {
      this.submitted = true;
      this.loan.status = status == 1 ? 0 : 2;
      this.loan.approvedByAGM =
        this.currentUser.employee.id;
      this.loan.approvedDateByAGM = new Date();
      this.loading = true;
      employeeService.updateLoanRequest(this.loan.id, this.loan).then(
        id => {
          employeeService.getEmployeeDepartLoans(
        this.currentUser.employee.companyUnitId,
        this.currentUser.employee.id,
          this.currentUser.employee.designation.departmentId
      ).then(o => {
            this.loans = o.filter(c => (c.approvedByManager != null && c.approvedByManager != this.currentUser.employee.id && c.employeeId != this.currentUser.employee.id && this.currentUser.employee.levelType == 1)
            || (c.approvedByManager != null && c.employeeId != this.currentUser.employee.id && this.currentUser.employee.levelType != 1));
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getLoans() {
      let currentUserDepart = this.currentUser;
      console.log(this.currentUser);
      console.log(this.company);
      employeeService.getEmployeeDepartLoans(
        currentUserDepart.employee.companyUnitId,
        currentUserDepart.employee.id,
          currentUserDepart.employee.designation.departmentId
      ).then(
        o => {
          this.loans = o.filter(c => (c.approvedByManager != null && c.approvedByManager != currentUserDepart.employee.id && currentUserDepart.roles.includes('HOU'))
            || (c.approvedByManager != null && currentUserDepart.roles.includes('HOD')));
        },
        error => {
          error = error;
        }
      );
    },
    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.loading = true;
      this.loan.requestDate = new Date();
      this.loan.employeeId = this.currentUser.employee.id;
      this.loan.loanType = null;
      employeeService.addLoanRequest(this.loan).then(
        id => {
          this.message = "Loan Request Added successfully";
          employeeService
            .getLoanRequestsByEmployee(this.currentUser.employee.id)
            .then(model => {
              this.loans = model;
              this.message = "";
              this.close();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    calculateLoan(tenor) {
      this.submitted = true;
      this.loading = true;
      var loan = {
        loanTypeId: this.loanTypeId,
        amount: this.amount,
        actualTenor: tenor
      };
      employeeService.calculateLoan(loan).then(
        model => {
          this.loan = model;
          this.loan.repaymentStartDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            new Date().getDate()
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.isEmployeeManager();
    this.getLoanTypes();
    this.getLoans();

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/loans/loan/agmloan.vue